// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-XNw74nsblLFc84KbttCg {
    cursor: pointer;
}

.title-XNw74nsblLFc84KbttCg:hover {
    color: var(--dark-grey);
}

.men-women-selector-MfX14LXyzmUn3E9OtaXq {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: 200px;
}

/* Toggle button CSS */
/* https://www.w3schools.com/howto/howto_css_switch.asp */
/* The switch - the box around the slider */
.switch-Wm_07V2zXDkSRy7keHPK {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

/* Hide default HTML checkbox */
.switch-Wm_07V2zXDkSRy7keHPK input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider-MrVuDzNmXmllOa7IfYCv {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider-MrVuDzNmXmllOa7IfYCv:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .slider-MrVuDzNmXmllOa7IfYCv {
    background-color: #2196f3;
}

input:focus + .slider-MrVuDzNmXmllOa7IfYCv {
    box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider-MrVuDzNmXmllOa7IfYCv:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider-MrVuDzNmXmllOa7IfYCv.round-UId5l1OCqu5C574kXOdL {
    border-radius: 34px;
}

.slider-MrVuDzNmXmllOa7IfYCv.round-UId5l1OCqu5C574kXOdL:before {
    border-radius: 50%;
}
/* END Toggle button CSS */
`, "",{"version":3,"sources":["webpack://./src/header.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;AAChB;;AAEA,sBAAsB;AACtB,yDAAyD;AACzD,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;AACA,0BAA0B","sourcesContent":[".title {\n    cursor: pointer;\n}\n\n.title:hover {\n    color: var(--dark-grey);\n}\n\n.men-women-selector {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 200px;\n}\n\n/* Toggle button CSS */\n/* https://www.w3schools.com/howto/howto_css_switch.asp */\n/* The switch - the box around the slider */\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 34px;\n}\n\n/* Hide default HTML checkbox */\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n/* The slider */\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\n.slider:before {\n    position: absolute;\n    content: \"\";\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\ninput:checked + .slider {\n    background-color: #2196f3;\n}\n\ninput:focus + .slider {\n    box-shadow: 0 0 1px #2196f3;\n}\n\ninput:checked + .slider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n    border-radius: 34px;\n}\n\n.slider.round:before {\n    border-radius: 50%;\n}\n/* END Toggle button CSS */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `title-XNw74nsblLFc84KbttCg`,
	"men-women-selector": `men-women-selector-MfX14LXyzmUn3E9OtaXq`,
	"menWomenSelector": `men-women-selector-MfX14LXyzmUn3E9OtaXq`,
	"switch": `switch-Wm_07V2zXDkSRy7keHPK`,
	"slider": `slider-MrVuDzNmXmllOa7IfYCv`,
	"round": `round-UId5l1OCqu5C574kXOdL`
};
export default ___CSS_LOADER_EXPORT___;
